import './Spinner.css';
function Spinner() {
  return (
    <div>
      <div className="spinner w-2 h-2  mx-auto mt-52 "></div>
    </div>
  );
}
export default Spinner;
